import { suspense } from '../../lazy-loading'
import { ApolloClient, EventBus, Info, Global, Main } from '~/core/core-modules'
import { ConsultationContext } from '~/core/config/context'
import { useModelProvider } from '~/core/container/provider'
import { LazyAdminPortalPage, AdminPortalPageNavigationItem } from '~/features/admin-portal-view/AdminPortalScreens'
import { ScheduleCheckIn, ConsultationCheckIn } from '~/features/appointment-check-in/AppointmentCheckIn'
import AppointmentInvitesPlugin from '~/features/appointment-invites/AppointmentInvites'
import AppointmentInvitesSummaryPlugin from '~/features/appointment-invites/AppointmentInvitesSummary'
import AttachmentsPlugin from '~/features/attachments'
import AttachmentsSummaryPlugin from '~/features/attachments/AttachmentsSummary'
import BookingReasonSummaryPlugin from '~/features/booking-reason/BookingReasonSummary'
import BookingReasonPlugin from '~/features/booking-reason/BookingReasonSection'
import { CallStatusReducerModelProvider } from '~/features/call/CallStatusReducerModelProvider'
import CallPlugin from '~/features/call'
import CarePlanSummaryPlugin from '~/features/care-plan/CarePlanSummary'
import CarePlanSectionPlugin from '~/features/care-plan/CarePlanSection'
import { DoNotInstantiate, CompleteConsultationModel, CompleteDialogPlugin, ConsultationActionsPlugin, MarkAsSensitiveModel, MarkAsSensitivePlugin, UsEhrNotesCompletionModel, InsuranceClaimCheckModel, InsuranceClaimCheckPlugin, CarePlansCompletionModel } from '~/features/complete-consultation'
import { EditedConsultationWarningModelProvider } from '~/features/complete-consultation/EditedConsultationWarning'
import { GoogleFormDialog } from '~/features/google-form-dialog'
import CallActiveModalPlugin from '~/features/call/CallActiveModal/CallActiveModal'
import { LazyConsultationLitePage } from '~/features/consultation'
import ExternalTabsWarningBannerPlugin from '~/features/consultation/ExternalTabsWarning'
import IncompleteConsultationWarningModalPlugin from '~/features/consultation/IncompleteConsultationWarning'
import ConsultationProfilePlugin from '~/features/consultation-profile'
import { LazyAllConsultationsPage, AllConsultationsPageNavigationItem } from '~/features/consultation-search/AllConsultationsPage'
import PastConsultationSummaryPlugin from '~/features/consultation-summary/ConsultationSummary/PastConsultationSummary'
import CurrentConsultationSummaryPlugin from '~/features/consultation-summary/ConsultationSummary/CurrentConsultationSummary'
import DocumentRepositoryPlugin from '~/features/document-repository/DocumentTable'
import EhrCheckInUsPlugin from '~/features/ehr-checkin-us'
import USEhrSummaryPlugin from '~/features/us-ehr/USEhrSummary'
import ExperimentsPage from '~/features/experiments'
import GpDetailsPlugin from '~/features/gp-details/GpDetails'
import { Header } from '~/features/header'
import { Layout } from '~/features/layout'
import LinksAndResourcesPlugin from '~/features/links-and-resources'
import { Navigation } from '~/features/navigation'
import NoteAssistantSummaryPlugin from '~/features/note-assistant/NoteAssistantSummary'
import CallRecordingPlugin from '~/features/note-assistant/CallRecording/CallRecording'
import PatientAlertsPlugin from '~/features/patient-alerts'
import PatientDetailsPlugin from '~/features/patient-details'
import PatientRecordDeepLinkPlugin from '~/features/patient-record-deep-link'
import TimelineConsultationEventPlugin from '~/features/patient-timeline/Timeline/components/TimelineConsultationEvent'
import PatientTimelinePlugin from '~/features/patient-timeline/Timeline'
import PreconsultationSummaryPlugin from '~/features/pre-consultation-flow/PreconsultationSummary'
import PreConsultationFlowPlugin from '~/features/pre-consultation-flow/PreConsultationSection'
import ReleaseNotesPlugin from '~/features/release-notes'
import { LazySchedulePage, SchedulePageNavigationItem } from '~/features/schedule/SchedulePage'
import ConsultationScheduleItemPlugin from '~/features/schedule/ConsultationScheduleItem'
import SectionGroupPlugin from '~/features/section-group'
import Routes from '~/features/shell/Routes'
import { LazyTelusAsyncChatPage, TelusAsyncChatPageNavigationItem } from '~/features/telus-async-chat'
import USEhrDeepLinkPlugin from '~/features/us-ehr/USEhrDeepLink'

export const modules = {
  ApolloClient,
  EventBus,
  Info,
  Global,
  ConsultationContext,
  AbstractModelProvider: useModelProvider,
  Main,
  AdminPortalPage: suspense(LazyAdminPortalPage),
  AdminPortalPageNavigationItem,
  ScheduleCheckInPlugin: ScheduleCheckIn,
  ConsultationCheckInPlugin: ConsultationCheckIn,
  AppointmentInvitesPlugin,
  AppointmentInvitesSummaryPlugin,
  AttachmentsPlugin,
  AttachmentsSummaryPlugin,
  BookingReasonSummaryPlugin,
  BookingReasonPlugin,
  CallStatusReducerModelProvider,
  CallPlugin,
  CarePlanSummaryPlugin,
  CarePlanSectionPlugin,
  AbstractCompleteConsultationExtension: DoNotInstantiate,
  CompleteConsultationModel,
  CompleteDialogPlugin,
  EditedConsultationWarningModelProvider,
  PostConsultationFormModal: GoogleFormDialog,
  CallActiveModalPlugin,
  ConsultationActionsPlugin,
  MarkAsSensitiveModel,
  MarkAsSensitivePlugin,
  UsEhrNotesCompletionModel,
  InsuranceClaimCheckModel,
  InsuranceClaimCheckPlugin,
  CarePlansCompletionModel,
  ConsultationLitePage: suspense(LazyConsultationLitePage),
  ExternalTabsWarningBannerPlugin,
  IncompleteConsultationWarningModalPlugin,
  ConsultationProfilePlugin,
  AllConsultationsPage: suspense(LazyAllConsultationsPage),
  AllConsultationsPageNavigationItem,
  PastConsultationSummaryPlugin,
  CurrentConsultationSummaryPlugin,
  DocumentRepositoryPlugin,
  EhrCheckInUsPlugin,
  USEhrSummaryPlugin,
  ExperimentsPage,
  GpDetailsPlugin,
  Header,
  Layout,
  LinksAndResourcesPlugin,
  Navigation,
  NoteAssistantSummaryPlugin,
  CallRecordingPlugin,
  PatientAlertsPlugin,
  PatientDetailsPlugin,
  PatientRecordDeepLinkPlugin,
  TimelineConsultationEventPlugin,
  PatientTimelinePlugin,
  PreconsultationSummaryPlugin,
  PreConsultationFlowPlugin,
  ReleaseNotesPlugin,
  SchedulePage: suspense(LazySchedulePage),
  SchedulePageNavigationItem,
  ConsultationScheduleItemPlugin,
  SectionGroupPlugin,
  Routes,
  TelusAsyncChatPage: suspense(LazyTelusAsyncChatPage),
  TelusAsyncChatPageNavigationItem,
  USEhrDeepLinkPlugin
}
